import { AccountStatusEnum, AccountSubscriptionEnum, SnackBarVariants } from '@app/app.enum';
import withSnackBar from '@app/components/core/message.component';
import CustomButton from '@app/components/shared/custom-button.component';
import CustomDialogBox from '@app/components/shared/dialog.component';
import * as constants from '@app/constants';
import * as models from '@app/models';
import Injector from '@app/services';
import { AdminAccountService } from '@app/services/admin-account.service';
import { SharedService } from '@app/services/shared.service';
import { Card, CardActions, CardContent, CardHeader, Grid, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import { FormattedDate, injectIntl } from 'react-intl';

const sharedService: SharedService = Injector.get(SharedService);
const adminAccountService: AdminAccountService = Injector.get(AdminAccountService);

class ProductDetailsComponent extends Component<models.IProductDetailsProp, models.IProductDetailsState> {
	constructor(props: models.IProductDetailsProp) {
		super(props);
		this.state = {
			subscriptionPlans: [],
			disableChangePlan: true,
			currentPlan: props.account.subscriptionPlan,
			selectedPlan: null,
			loading: false,
			account: props.account,
			openDialog: false,
		};
	}

	public componentDidMount() {
		this.getSubscriptionPlans();
	}

	public componentDidUpdate(prevProp: models.IProductDetailsProp, prevState: models.IProductDetailsState) {
		if (prevProp.account.subscriptionPlan !== this.props.account.subscriptionPlan) {
			this.setState({
				currentPlan: this.props.account.subscriptionPlan,
			});
		}

		if (prevProp.account !== this.props.account) {
			this.setState({
				account: this.props.account,
			});
		}
	}

	public render() {
		const dialogDescription = this.props.intl.formatHTMLMessage(
			{
				id: 'app.account-details.product-detail.change-plan-dialog-description',
			},
			{
				0: AccountSubscriptionEnum[this.state.selectedPlan],
				1: AccountSubscriptionEnum[this.state.currentPlan],
			}
		);
		return (
			<React.Fragment>
				<CustomDialogBox
					open={this.state.openDialog}
					dialogTitle={this.props.intl.formatMessage({
						id: 'app.account-details.product-detail.change-plan-label',
					})}
					dialogDescription={dialogDescription}
					closeCustomDialog={(dialogPannel: string, isCancel: boolean) => {
						if (!isCancel) {
							this.updatePlan();
						}
						this.setState({
							openDialog: false,
							loading: false,
						});
					}}
				/>
				<Grid container={true} spacing={2}>
					{this.state.subscriptionPlans.map((product) => (
						<Grid item={true} xs={3} key={product.plan}>
							<Card
								square={true}
								classes={{
									root: 'subscription-plan-card',
								}}
							>
								<CardHeader
									classes={{
										root: 'header',
									}}
									title={
										<Typography className='card-heading' component='h5' noWrap={true} align='center'>
											{AccountSubscriptionEnum[product.plan]}
										</Typography>
									}
								/>
								<CardContent classes={{ root: 'text-center' }}>
									<Typography variant='body2' gutterBottom={true} noWrap={true}>
										{`${this.props.intl.formatMessage({
											id: 'product-details.call-per-day-label',
										})}: ${product.callsAllowedPerDay}`}
									</Typography>
									<Typography variant='body2' gutterBottom={true} noWrap={true}>
										{`${this.props.intl.formatMessage({
											id: 'product-details.call-per-minute-label',
										})}: ${product.callsAllowedPerMinute}`}
									</Typography>
								</CardContent>

								<CardActions>
									<Grid container={true} justifyContent='center'>
										<Grid item={true}>
											{this.state.account.subscriptionPlan === product.plan ? (
												<Typography
													color='primary'
													variant='subtitle1'
													noWrap={true}
													align='center'
													className='text-uppercase'
												>
													{`${this.props.intl.formatMessage({
														id: 'product-details.active-since-label',
													})}`}{' '}
													<FormattedDate
														{...constants.dateFormatOptions}
														value={sharedService.getNewDateIfNotExist(this.state.account.subscriptionPlanChangeDate)}
													/>
												</Typography>
											) : (
												!this.props.isPartnerAccount && (
													<CustomButton
														disabled={this.props.account.status === AccountStatusEnum.Closed}
														loading={product.plan === this.state.selectedPlan && this.state.loading}
														buttonText={this.props.intl.formatMessage({
															id: 'product-details.select-plan-label',
														})}
														onClick={async () => {
															this.setState({
																selectedPlan: product.plan,
																loading: true,
																openDialog: true,
															});
														}}
													/>
												)
											)}
										</Grid>
									</Grid>
								</CardActions>
							</Card>
						</Grid>
					))}
				</Grid>
			</React.Fragment>
		);
	}

	private getSubscriptionPlans = async () => {
		try {
			const result = await adminAccountService.GetSubscriptionPlanStaticData();
			this.setState({
				subscriptionPlans: result,
			});
		} catch (err) {
			throw err;
		}
	};

	// on plan change
	private async updatePlan() {
		try {
			const account = await adminAccountService.UpdateSubscriptionPlan({
				plan: this.state.selectedPlan,
				accountId: this.props.account.id,
			});

			this.setState({
				currentPlan: this.state.selectedPlan,
			});

			this.props.openSnackBar(
				this.props.intl.formatMessage({
					id: 'product-details.snackbar-update-successful',
				})
			);

			this.setState({
				loading: false,
				disableChangePlan: true,
				account,
			});
		} catch (error) {
			this.props.openSnackBar(sharedService.parseError(error.data), SnackBarVariants.Error);
		}
	}
}

export default withSnackBar(injectIntl(ProductDetailsComponent));



// WEBPACK FOOTER //
// ./src/components/shared/product-details.component.tsx